var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Oidc, { UserManager, User } from "oidc-client";
import { getLogger } from "@parcel2go/logging";
export { User };
var settings = {
    authority: process.env.REACT_APP_AUTHORITY || "https://www.parcel2go.com/auth",
    client_id: process.env.REACT_APP_CLIENTID,
    redirect_uri: window.location.origin + "/signin-callback.html",
    silent_redirect_uri: window.location.origin + "/silent-callback.html",
    post_logout_redirect_uri: window.location.href,
    response_type: "id_token token",
    scope: process.env.REACT_APP_SCOPES || "openid profile public-api authorizer",
    loadUserInfo: true,
    automaticSilentRenew: true,
    monitorSession: true,
    accessTokenExpiringNotificationTime: 300,
};
var Auth = /** @class */ (function () {
    function Auth() {
        this._logger = getLogger();
        Oidc.Log.logger = this._logger;
        this._logger.debug("Auth setting %j", settings);
        this._userManager = new UserManager(settings);
        this.configureEvents();
    }
    Auth.prototype.getUserOrSignIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._userManager.getUser()];
                    case 1:
                        user = _a.sent();
                        if (!!user) return [3 /*break*/, 3];
                        this.login();
                        return [4 /*yield*/, this._userManager.getUser()];
                    case 2:
                        user = _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, user];
                }
            });
        });
    };
    Auth.prototype.getUser = function () {
        this._logger.debug("Getting user");
        return this._userManager.getUser();
    };
    Auth.prototype.login = function () {
        this._logger.debug("Login");
        return this._userManager.signinRedirect({ state: window.location.href });
    };
    Auth.prototype.renewToken = function () {
        this._logger.debug("Renew Token");
        return this._userManager.signinSilent();
    };
    Auth.prototype.logout = function () {
        this._logger.debug("Logout");
        return this._userManager.signoutRedirect();
    };
    Auth.prototype.configure = function () {
        this._logger.debug("Auth Configure %j", settings);
        this._userManager = new UserManager(settings);
        this.configureEvents();
    };
    Auth.prototype.getSettings = function () {
        return this._userManager.settings;
    };
    Auth.prototype.configureEvents = function () {
        var _this = this;
        this._userManager.events.addUserSignedOut(function () {
            _this._userManager.removeUser();
            _this._userManager.signinRedirect({ state: window.location.href });
        });
        this._userManager.events.addAccessTokenExpiring(function () {
            _this._logger.warn("Access Token Expiring");
        });
        this._userManager.events.addAccessTokenExpired(function () {
            _this._logger.warn("Access Token Expired");
        });
        this._userManager.events.addSilentRenewError(function () {
            _this._logger.error("Silent Renew Error");
        });
    };
    return Auth;
}());
export { Auth };
export function configureAuth(config) {
    settings.authority = config.authority;
    currentAuth.configure();
    return settings;
}
export var currentAuth = new Auth();
